import React from "react";
import Diya from "./Diya";
import { useStore } from "@/store/StoreContext";

export default function DiwaliDays() {
  const { showcase, content } = useStore();
  const DAYS = showcase.diwali_day || [];
  if (!DAYS.length) return null;
  return (
    <section data-testid="diwali-days" className="relative overflow-hidden bg-[#F6EEDC] py-14 lg:py-16">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="reveal mb-10 text-center">
          <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.34em] text-[#8F6E1D]">{content?.days_eyebrow || "Panch Parva"}</p>
          <h2 className="font-display text-3xl font-semibold tracking-tight text-[#2B1E12] sm:text-4xl">
            {content?.days_title || "The Five Days of"} <span className="text-gold-gradient italic">{content?.days_accent || "Diwali"}</span>
          </h2>
        </div>
        <div className={`grid gap-4 sm:grid-cols-2 ${DAYS.length >= 5 ? "lg:grid-cols-5" : DAYS.length === 4 ? "lg:grid-cols-4" : "lg:grid-cols-3"}`}>
          {DAYS.map((d, i) => (
            <article
              key={d.id || d.name}
              data-testid={`diwali-day-${i}`}
              className="reveal group rounded-md border border-[#E0D3B4] bg-[#FDF8F0] p-5 text-center transition-all duration-500 hover:-translate-y-1.5 hover:border-[#B08D2B]/50 hover:shadow-[0_20px_45px_-18px_rgba(143,110,29,0.35)]"
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              {d.image ? (
                <img src={d.image} alt={d.name} className="mx-auto mb-3 h-14 w-14 rounded-full object-cover transition-transform duration-500 group-hover:scale-110" />
              ) : (
                <div className="mx-auto mb-3 w-fit transition-transform duration-500 group-hover:scale-110">
                  <Diya size={46} />
                </div>
              )}
              <p className="mb-1 text-[10px] font-bold uppercase tracking-[0.24em] text-[#B34A00]">Day {i + 1}</p>
              <h3 className="font-display text-lg font-semibold text-[#2B1E12]">{d.name}</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-[#6B5B45]">{d.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
